export default "__VITE_ASSET__Dm9xzBIK__"